import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { usePatient } from "src/context/PatientProvider";
import WelcomeVideo from "src/pages/PatientDashboard/components/WelcomeVideo";
import WhiteCard from "src/shared/components/WhiteCard";

const PatientWelcomePackage = () => {
  const firstName = usePatient((patient) => patient.profile.first_name);
  const language = usePatient((patient) => patient.profile.language);
  const { t } = useTranslation();
  const component = "patient-dashboard.welcome-message";

  return (
    <Stack gap={2}>
      <WelcomeVideo language={language} />
      <WhiteCard gap={2}>
        <Typography variant="h6" fontWeight={700}>
          {t(`${component}.header`, "Dr. Azouz, Medical Director")}
        </Typography>
        <Stack spacing={2}>
          <Typography>
            {t(`${component}.text-1`, "Hi {{firstName}},", {
              firstName: firstName,
            })}
          </Typography>
          <Typography>
            {t(
              `${component}.text-2`,
              "This is Dr. Azouz, a board-certified physician and the Medical Director at HolaVida Health. Welcome to HolaVida Health. Your intake information is in and I'll be reviewing it shortly. We’re so happy you’re taking this step in your health journey and I’m glad to be leading your care team.",
            )}
          </Typography>
          <Typography>
            {t(
              `${component}.text-3`,
              "We've helped thousands of patients reach their goals and I'm excited to do the same with you. Looking forward to building a plan that works for your life. If any medical questions come up along the way, you can always contact me.",
            )}
          </Typography>
        </Stack>
      </WhiteCard>
    </Stack>
  );
};

export default PatientWelcomePackage;
